import React from 'react';
import styles from './FileComponent.module.scss';
import { ReactComponent as FileFromDocument } from '../../../../resource/FileFromDocument.svg';
import { ReactComponent as DeleteFromDocumentIcon } from '../../../../resource/DeleteFromDocumentIcon.svg';
import { Modal, Spin, Tooltip } from 'antd';
import useDeleteDocsAttachFile from '../../mutation/useDeleteDocsAttachFile';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import { useSelector } from 'react-redux';
import { useVisiblePreview } from '../DocFormProvider';

const { confirm } = Modal;

const FileComponent = ({
  file,
  index,
  removeFile,
  handleOpenPreview,
  onChangePreview,
  files,
}) => {
  const fileMap = file?.name.split('.');
  const fileName =
    fileMap?.length > 2 ? fileMap.slice(0, -1).join('.') : fileMap[0];
  const fileType = fileMap[fileMap.length - 1];

  const visiblePreview = useVisiblePreview();

  const { mode } = useSelector(documentDrawerSelector);

  const { isLoading, onMutation } = useDeleteDocsAttachFile();

  const handleClickRemove = () => {
    if (mode === 'edit') {
      confirm({
        title: 'Вы действительно хотите удалить этот файл?',
        zIndex: 100000,
        async onOk() {
          if (files?.length === 1 || !visiblePreview) {
            onChangePreview(null);
          } else {
            onChangePreview({
              visible: true,
              value: visiblePreview?.value - 1 || 0,
            });
          }

          await onMutation({ docId: file?.docId, attachId: file?.id });
        },
        onCancel() {},
      });
    } else {
      removeFile(index);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.leftBlock}>
        <div className={styles.iconBlock}>
          <FileFromDocument style={{ color: '#3378F9' }} />
        </div>
        <Tooltip
          title="Открыть превью"
          placement="top"
        >
          <div
            className={styles.nameBlock}
            onClick={() => handleOpenPreview(index)}
          >
            <div className={styles.filename}>
              <span className={styles.name}>{fileName}</span>
              <span className={styles.ext}>.{fileType}</span>
            </div>
            {/* <div className={styles.size}>{formatBytesRus(file.size, 1)}</div> */}
          </div>
        </Tooltip>
      </div>
      <div className={styles.btnBlock}>
        {isLoading ? (
          <Spin />
        ) : (
          <DeleteFromDocumentIcon
            className={styles.iconRemove}
            onClick={handleClickRemove}
          />
        )}
      </div>
    </div>
  );
};

export default FileComponent;
